"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInitializeSellOrderInstruction = exports.createInitializeBuyOrderInstruction = void 0;
const anchor_1 = require("@project-serum/anchor");
const utils_1 = require("../utils");
const util_1 = require("../../util");
const pda_getters_1 = require("../pda_getters");
const createOrderCounter_1 = require("./createOrderCounter");
const util_2 = require("../../util");
/**
 * Returns an instruction which creates an order to purchase originationQty of ReceiveToken at 'price' value per unit
 *
 * @param connection
 * @param initializerMainAccount - Public key of user creating order
 * @param initializerDepositTokenAccount - Public key of token account for token being ordered
 * @param initializerReceiveTokenAccount - Public key of token account for token to be received
 * @param orderAccount - Keypair of an initialized orderAccount
 * @param price - Price of individual unit
 * @param originationQty - Number of units to purchase
 * @param depositMint - Mint address of token being ordered
 * @param receiveMint - Mint address of token being purchased
 * @param programId - Deployed program ID for GM program
 */
function createInitializeBuyOrderInstruction({ connection, initializerMainAccount, initializerDepositTokenAccount, price, originationQty, depositMint, receiveMint, programId, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const program = (0, utils_1.getMarketplaceProgram)({ connection, programId });
        const ixSet = {
            signers: [],
            instructions: [],
        };
        // Derive ATAs for deposit and receive mints
        let tokenAccount = null;
        let initializerReceiveTokenAccount = null;
        const response = yield (0, util_1.getTokenAccount)(connection, initializerMainAccount, receiveMint);
        tokenAccount = response.tokenAccount;
        if ('createInstruction' in response) {
            ixSet.instructions.push(response.createInstruction);
        }
        if (tokenAccount instanceof anchor_1.web3.Keypair) {
            initializerReceiveTokenAccount = tokenAccount.publicKey;
            ixSet.signers.push(tokenAccount);
        }
        else {
            initializerReceiveTokenAccount = tokenAccount;
        }
        // Derive the open orders counter, initializing if necessary
        const [counterAddress] = yield (0, pda_getters_1.getOpenOrdersCounter)(initializerMainAccount, depositMint, programId);
        const orderCounter = yield connection.getAccountInfo(counterAddress);
        if (orderCounter === null) {
            const createCounterIx = yield (0, createOrderCounter_1.createOrderCounterInstruction)({
                connection,
                payer: initializerMainAccount,
                initializerMainAccount,
                depositMint,
                programId,
            });
            ixSet.instructions.push(createCounterIx);
        }
        const orderAccount = anchor_1.web3.Keypair.generate();
        ixSet.signers.push(orderAccount);
        const orderAccountIx = yield (0, util_2.createAccountInstruction)(connection, initializerMainAccount, orderAccount, programId);
        ixSet.instructions.push(orderAccountIx);
        const ix = yield program.methods
            .processInitializeBuy(price, new anchor_1.BN(originationQty))
            .accounts({
            orderInitializer: initializerMainAccount,
            initializerDepositTokenAccount,
            initializerReceiveTokenAccount,
            orderAccount: orderAccount.publicKey,
            depositMint,
            receiveMint,
        })
            .signers([orderAccount])
            .instruction();
        ixSet.instructions.push(ix);
        return { orderAccount: orderAccount.publicKey, ixSet };
    });
}
exports.createInitializeBuyOrderInstruction = createInitializeBuyOrderInstruction;
/*
 * Returns an instruction which creates an order to sell originationQty of DepositToke;n at 'price' value per unit
 *
 * @param connection
 * @param orderInitializer - Public key of order initializer
 * @param initializerDepositTokenAccount - Public key of token account for token being ordered
 * @param initializerReceiveTokenAccount - Public key of token account for token to be received
 * @param orderAccount - Keypair of an initialized orderAccount
 * @param price - Price of individual unit
 * @param originationQty - Number of units to purchase
 * @param depositMint - Mint address of token being ordered
 * @param receiveMint - Mint address of token being purchased
 * @param programId - Deployed program ID for GM program
 */
function createInitializeSellOrderInstruction({ connection, initializerMainAccount, initializerDepositTokenAccount, price, originationQty, depositMint, receiveMint, programId, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const program = (0, utils_1.getMarketplaceProgram)({ connection, programId });
        const ixSet = {
            signers: [],
            instructions: [],
        };
        // Derive ATAs for deposit and receive mints
        let tokenAccount = null;
        let initializerReceiveTokenAccount = null;
        const response = yield (0, util_1.getTokenAccount)(connection, initializerMainAccount, receiveMint);
        tokenAccount = response.tokenAccount;
        if ('createInstruction' in response) {
            ixSet.instructions.push(response.createInstruction);
        }
        if (tokenAccount instanceof anchor_1.web3.Keypair) {
            initializerReceiveTokenAccount = tokenAccount.publicKey;
            ixSet.signers.push(tokenAccount);
        }
        else {
            initializerReceiveTokenAccount = tokenAccount;
        }
        // Derive the open orders counter, initializing if necessary
        const [counterAddress] = yield (0, pda_getters_1.getOpenOrdersCounter)(initializerMainAccount, depositMint, programId);
        const orderCounter = yield connection.getAccountInfo(counterAddress);
        if (orderCounter === null) {
            const createCounterIx = yield (0, createOrderCounter_1.createOrderCounterInstruction)({
                connection,
                payer: initializerMainAccount,
                initializerMainAccount,
                depositMint,
                programId,
            });
            ixSet.instructions.push(createCounterIx);
        }
        const orderAccount = anchor_1.web3.Keypair.generate();
        ixSet.signers.push(orderAccount);
        const orderAccountIx = yield (0, util_2.createAccountInstruction)(connection, initializerMainAccount, orderAccount, programId);
        ixSet.instructions.push(orderAccountIx);
        const ix = yield program.methods
            .processInitializeSell(price, new anchor_1.BN(originationQty))
            .accounts({
            orderInitializer: initializerMainAccount,
            initializerDepositTokenAccount,
            initializerReceiveTokenAccount,
            orderAccount: orderAccount.publicKey,
            depositMint,
            receiveMint,
        })
            .signers([orderAccount])
            .instruction();
        ixSet.instructions.push(ix);
        return { orderAccount: orderAccount.publicKey, ixSet };
    });
}
exports.createInitializeSellOrderInstruction = createInitializeSellOrderInstruction;
//# sourceMappingURL=createOrder.js.map